import React from 'react';

const LoadingSpinner = ({ logo }) => (
  <div className="flex items-center justify-center h-screen bg-surface">
    <div className="relative w-24 h-24 animate-spin rounded-full border-4 border-t-transparent" style={{ borderColor: 'var(--color-primary, #8EA58C)', borderTopColor: 'transparent' }}>
      <img src={logo} alt="Wedding Logo" className="absolute inset-0 m-auto w-16 h-16 object-contain" />
    </div>
  </div>
);

export default LoadingSpinner;